/**
 * Quick Start documentation page content.
 *
 * Step-by-step guide to get developers running their first teammate.
 * Kept intentionally short — 2 steps max, ends after the first run.
 */

export const quickstartContent = `
Get your first autonomous teammate running in under 2 minutes.

## Prerequisites

- Python 3.8+
- An API key from the [Developer dashboard](https://m8tes.ai/developer) (starts with \`m8_\`)

## 1. Install the SDK

\`\`\`bash
pip install m8tes
\`\`\`

Set your API key:

\`\`\`bash
export M8TES_API_KEY=m8_your_key_here
\`\`\`

## 2. Run Your First Teammate

**This auto-creates a teammate and starts a run in one call:**

\`\`\`python
from m8tes import M8tes

client = M8tes()

run = client.runs.create(
    name="News Bot",
    instructions="You summarize news concisely",
    message="Summarize the latest AI news",
    stream=False,
)
run = client.runs.poll(run.id)
print(run.output)
\`\`\`

\`\`\`bash
# Create a run (auto-creates a teammate, returns immediately)
curl -X POST https://m8tes.ai/api/v2/runs \\
  -H "Authorization: Bearer m8_your_key_here" \\
  -H "Content-Type: application/json" \\
  -d '{"name": "News Bot", "instructions": "You summarize news concisely", "message": "Summarize the latest AI news", "stream": false}'

# Poll until complete
curl https://m8tes.ai/api/v2/runs/1 \\
  -H "Authorization: Bearer m8_your_key_here"
\`\`\`

That's it. The SDK creates a teammate behind the scenes and runs your message. \`poll()\` waits until the run finishes and returns the result.

Or use the [CLI](/docs/cli) for the same thing from your terminal:

\`\`\`bash
m8tes mate task "Summarize the latest AI news"
\`\`\`

## What's Next

- [Teammates](/docs/teammates) — create reusable personas with tools
- [Runs](/docs/runs) — streaming, follow-ups, and more
- [Tasks](/docs/tasks) — reusable task definitions with triggers
- [Tools](/docs/skills) — browse and assign available tools
- [CLI](/docs/cli) — manage teammates and run tasks from the terminal
`;
